import { Field } from "./Field";
import { TEAM_LABELS } from "@/lib/labels";

export const StepTeam = ({ form, update }) => (
  <div className="space-y-8">
    <p className="text-sm text-slate-400">
      Add your team contacts below. Leave blank any roles that don't apply — email and phone are optional for each.
    </p>
    {Object.entries(TEAM_LABELS).map(([key, label]) => (
      <div key={key} className="xy-card p-5 md:p-6" data-testid={`team-block-${key}`}>
        <p className="font-display font-semibold text-slate-100 mb-4">{label}</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Field
            label="Name"
            testid={`input-team-${key}-name`}
            value={form.team[key].name}
            onChange={(e) => update(`team.${key}.name`, e.target.value)}
          />
          <Field
            label="Email"
            testid={`input-team-${key}-email`}
            type="email"
            value={form.team[key].email}
            onChange={(e) => update(`team.${key}.email`, e.target.value)}
          />
          <Field
            label="Phone"
            testid={`input-team-${key}-phone`}
            type="tel"
            value={form.team[key].phone}
            onChange={(e) => update(`team.${key}.phone`, e.target.value)}
          />
        </div>
      </div>
    ))}
  </div>
);
